import {BaseLanguageModel} from './base-language-model';

export class CountryEnEnLanguage extends BaseLanguageModel{
  AUTH_PASSWORD_PLACEHOLDER: string = this.AUTH_PASSWORD_PLACEHOLDER;
}
